import { shallowRef } from 'vue'
import { defineStore } from 'pinia'

export type MergeConflictAction = 'keepEditing' | 'useServer' | 'saveMine'

export type MergeConflictField = {
  key: string
  label: string
  baseValue: string
  serverValue: string
  draftValue: string
  serverChanged: boolean
  draftChanged: boolean
  conflict: boolean
}

export type MergeConflictRequest = {
  title: string
  message: string
  clientUpdatedAt?: string | null
  serverUpdatedAt?: string | null
  fields: MergeConflictField[]
}

export const useMergeConflictsStore = defineStore('mergeConflicts', () => {
  const active = shallowRef<MergeConflictRequest | null>(null)
  let resolver: ((action: MergeConflictAction) => void) | null = null

  function requestConflictDecision(request: MergeConflictRequest): Promise<MergeConflictAction> {
    active.value = request
    return new Promise((resolve) => {
      resolver = resolve
    })
  }

  function settle(action: MergeConflictAction): void {
    active.value = null
    const r = resolver
    resolver = null
    r?.(action)
  }

  return {
    active,
    requestConflictDecision,
    settle,
  }
})
